import { render, staticRenderFns } from "./AppFooterWhite.vue?vue&type=template&id=8d1c6aa0&scoped=true&"
import script from "./AppFooterWhite.vue?vue&type=script&lang=js&"
export * from "./AppFooterWhite.vue?vue&type=script&lang=js&"
import style0 from "./AppFooterWhite.vue?vue&type=style&index=0&id=8d1c6aa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1c6aa0",
  null
  
)

export default component.exports